import type { BrandCategory } from '@innovationdepartment/proxima-sdk-axios';
import { useToaster } from '@innovationdepartment/proxima-ui';
import { useProximaSDK } from 'hooks';
import { useNavigate } from 'react-router';

export type CreateBrandParams = {
  name: string;
  website: string;
  category: BrandCategory;
};

const useCreateBrand = () => {
  const brandsApi = useProximaSDK('BrandsApi');
  const audiencesApi = useProximaSDK('AudiencesApi');
  const { showToaster } = useToaster();
  const navigate = useNavigate();

  const createBrand = async (data: CreateBrandParams) => {
    const { website, category, name } = data;

    const brandResponse = await brandsApi.createBrand({
      createBrandRequest: { name, website, category }
    });

    // Legacy audience and Meta-integration services still read the category from audiences brand_settings.
    await audiencesApi.updateBrandSettings({
      brandId: brandResponse.data.brandId,
      updateBrandSettingsRequest: {
        flavorCategoryId: category
      }
    });

    showToaster({
      message: `Brand "${name}" created successfully!`,
      variant: 'success'
    });

    navigate(`/brand/${brandResponse.data.brandId}/overview`);
  };

  const loading = brandsApi.loading || audiencesApi.loading;

  return { loading, createBrand };
};

export default useCreateBrand;
